module.exports = "\n<div class=\"wrapper\">\n    <div class=\"sidebar\" data-color=\"white\" data-background-color=\"red\">\n        <app-sidebar-cmp></app-sidebar-cmp>\n        <div class=\"sidebar-background\"></div>\n    </div>\n    <div class=\"main-panel\">\n        <app-navbar-cmp></app-navbar-cmp>\n        <router-outlet></router-outlet>\n        <div *ngIf=\"!isMap()\">\n            <app-footer-cmp></app-footer-cmp>\n        </div>\n    </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/admin/admin-layout.component.html
// module id = ./src/app/layouts/admin/admin-layout.component.html
// module chunks = main